export const POLICY = `POLICY`;
export const GET_PHONE_DATA = `${POLICY}/GET_PHONE_DATA`;
export const GET_PO_FULL_NAME_DATA = `${POLICY}/GET_PO_FULL_NAME_DATA`;
export const GET_POLICY_PROVINCE = `${POLICY}/GET_POLICY_PROVINCE`;
export const SET_POLICY_PROVINCE = `${POLICY}/SET_POLICY_PROVINCE`;
export const GET_LIST_OF_VALUES_CLAIM_DOCUMENT = `${POLICY}/GET_LIST_OF_VALUES_CLAIM_DOCUMENT`;
export const SET_LIST_OF_VALUES_CLAIM_DOCUMENT = `${POLICY}/SET_LIST_OF_VALUES_CLAIM_DOCUMENT`;

export const GET_BANK_EMPLOYEE_CODE = `${POLICY}/GET_BANK_EMPLOYEE_CODE`;
export const SET_BANK_EMPLOYEE_CODE = `${POLICY}/SET_BANK_EMPLOYEE_CODE`;

export const GET_BANK_REFFERER_CODE = `${POLICY}/GET_BANK_REFFERER_CODE`;
export const SET_BANK_REFFERER_CODE = `${POLICY}/SET_BANK_REFFERER_CODE`;
